import {
  userBlue,
  userGreen,
  userOrange,
  userRed,
} from "@/common/components/icons/svg-icons";

export const userManagementTableHeaders = [
  "Username",
  "Email",
  "Phone Number",
  "Role",
  "Status",
];

export const userManagementTableKeys = [
  "user",
  "email",
  "phone",
  "role",
  "userStatus",
];

export const getUserManagementTableData = (_: any) => [
  {
    id: "1",
    user: { value: "Jane Doe", type: "string" },
    email: { value: "jane.doe@example.com", type: "string" },
    phone: { value: "+2347012345678", type: "string" },
    role: { value: "Pharmacist", type: "string" },
    userStatus: { value: "active", type: "string" },
  },
  {
    id: "2",
    user: { value: "John Smith", type: "string" },
    email: { value: "john.smith@example.com", type: "string" },
    phone: { value: "+2348011122233", type: "string" },
    role: { value: "Hospital Head", type: "string" },
    userStatus: { value: "suspended", type: "string" },
  },
  {
    id: "3",
    user: { value: "Amaka Okafor", type: "string" },
    email: { value: "amaka.okafor@example.com", type: "string" },
    phone: { value: "+2347065432198", type: "string" },
    role: { value: "Accountant", type: "string" },
    userStatus: { value: "inactive", type: "string" },
  },
  {
    id: "4",
    user: { value: "Samuel Johnson", type: "string" },
    email: { value: "samuel.j@example.com", type: "string" },
    phone: { value: "+2348034567890", type: "string" },
    role: { value: "Hospital Head", type: "string" },
    userStatus: { value: "active", type: "string" },
  },
  {
    id: "5",
    user: { value: "Fatima Yusuf", type: "string" },
    email: { value: "fatima.yusuf@example.com", type: "string" },
    phone: { value: "+2347059876543", type: "string" },
    role: { value: "Accountant", type: "string" },
    userStatus: { value: "active", type: "string" },
  },
  {
    id: "6",
    user: { value: "Michael Eze", type: "string" },
    email: { value: "michael.eze@example.com", type: "string" },
    phone: { value: "+2348098765432", type: "string" },
    role: { value: "Pharmacist", type: "string" },
    userStatus: { value: "pending", type: "string" },
  },
  {
    id: "7",
    user: { value: "Grace Nwosu", type: "string" },
    email: { value: "grace.nwosu@example.com", type: "string" },
    phone: { value: "+2348023456789", type: "string" },
    role: { value: "Accountant", type: "string" },
    userStatus: { value: "suspended", type: "string" },
  },
  {
    id: "8",
    user: { value: "Peter Obi", type: "string" },
    email: { value: "peter.obi@example.com", type: "string" },
    phone: { value: "+2347019876543", type: "string" },
    role: { value: "Hospital Head", type: "string" },
    userStatus: { value: "inactive", type: "string" },
  },
  {
    id: "9",
    user: { value: "Linda Ikeji", type: "string" },
    email: { value: "linda.ikeji@example.com", type: "string" },
    phone: { value: "+2348101234567", type: "string" },
    role: { value: "Pharmacist", type: "string" },
    userStatus: { value: "active", type: "string" },
  },
  {
    id: "10",
    user: { value: "Ahmed Musa", type: "string" },
    email: { value: "ahmed.musa@example.com", type: "string" },
    phone: { value: "+2348134567890", type: "string" },
    role: { value: "Accountant", type: "string" },
    userStatus: { value: "active", type: "string" },
  },
];

export const roleManagementTableHeaders = [
  "Name",
  "Email",
  "Role",
  "Permissions",
  "Status",
];

export const roleManagementTableKeys = [
  "name",
  "email",
  "role",
  "permissions",
  "status",
];

export const getRoleManagementTableData = (_: any) => [
  {
    id: "1",
    name: { value: "Jane Doe", type: "string" },
    email: { value: "jane@doe.com", type: "string" },
    role: { value: "Pharmacist", type: "string" },
    description: {
      value: "Handles medication dispensing and consultations",
      type: "string",
    },
    permissions: { value: "View, Create, Update", type: "string" },
    status: { value: "active", type: "string" },
  },
  {
    id: "2",
    name: { value: "John Smith", type: "string" },
    email: { value: "john@smith.com", type: "string" },
    role: { value: "Admin", type: "string" },
    description: {
      value: "Manages system-wide settings and users",
      type: "string",
    },
    permissions: { value: "View, Create, Update, Delete", type: "string" },
    status: { value: "active", type: "string" },
  },
  {
    id: "3",
    name: { value: "Alice Johnson", type: "string" },
    email: { value: "alice@healthcare.com", type: "string" },
    role: { value: "Nurse", type: "string" },
    description: {
      value: "Provides patient care and assistance",
      type: "string",
    },
    permissions: { value: "View, Update", type: "string" },
    status: { value: "inactive", type: "string" },
  },
  {
    id: "4",
    name: { value: "Mark Lee", type: "string" },
    email: { value: "mark@hospital.org", type: "string" },
    role: { value: "Lab Technician", type: "string" },
    description: {
      value: "Performs lab tests and reports results",
      type: "string",
    },
    permissions: { value: "View, Create", type: "string" },
    status: { value: "active", type: "string" },
  },
  {
    id: "5",
    name: { value: "Samantha Ray", type: "string" },
    email: { value: "samantha@clinic.com", type: "string" },
    role: { value: "Receptionist", type: "string" },
    description: {
      value: "Manages appointments and front desk operations",
      type: "string",
    },
    permissions: { value: "View, Update", type: "string" },
    status: { value: "active", type: "string" },
  },
  {
    id: "6",
    name: { value: "David Kim", type: "string" },
    email: { value: "david@clinic.com", type: "string" },
    role: { value: "Radiologist", type: "string" },
    description: {
      value: "Analyzes medical images and diagnostics",
      type: "string",
    },
    permissions: { value: "View", type: "string" },
    status: { value: "inactive", type: "string" },
  },
  {
    id: "7",
    name: { value: "Grace Lin", type: "string" },
    email: { value: "grace@hospital.org", type: "string" },
    role: { value: "Billing Officer", type: "string" },
    description: {
      value: "Manages invoices and billing systems",
      type: "string",
    },
    permissions: { value: "View, Create, Update", type: "string" },
    status: { value: "active", type: "string" },
  },
  {
    id: "8",
    name: { value: "Tom Hardy", type: "string" },
    email: { value: "tom@hardyclinic.com", type: "string" },
    role: { value: "IT Support", type: "string" },
    description: {
      value: "Maintains system operations and user tech support",
      type: "string",
    },
    permissions: { value: "View, Update", type: "string" },
    status: { value: "active", type: "string" },
  },
  {
    id: "9",
    name: { value: "Emily Carter", type: "string" },
    email: { value: "emily@carecenter.com", type: "string" },
    role: { value: "Care Coordinator", type: "string" },
    description: {
      value: "Coordinates patient care and treatment plans",
      type: "string",
    },
    permissions: { value: "View, Update", type: "string" },
    status: { value: "inactive", type: "string" },
  },
  {
    id: "10",
    name: { value: "Robert Brown", type: "string" },
    email: { value: "robert@hospital.com", type: "string" },
    role: { value: "Chief Medical Officer", type: "string" },
    description: {
      value: "Oversees clinical operations and medical staff",
      type: "string",
    },
    permissions: { value: "View, Create, Update, Delete", type: "string" },
    status: { value: "active", type: "string" },
  },
];

export const invitationForm = [
  {
    inputType: "text",
    name: "firstName",
    prompt: "First Name",
    rules: { required: true },
    placeholder: "Enter First Name",
    isFullWidth: false,
    required: true,
  },
  {
    inputType: "text",
    name: "lastname",
    prompt: " Last Name",
    placeholder: "Enter Last Name",
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "text",
    name: "email",
    prompt: "Email",
    placeholder: "Enter Email Address",
    rules: { required: true },
    isFullWidth: false,
    required: true,
  },
  {
    inputType: "text",
    name: "number",
    prompt: "Phone Number",
    placeholder: "Enter Phone Number",
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "selectInput",
    name: "role",
    prompt: "Role",
    initialValue: "Role",
    options: [
      { title: "Pharmacist", id: 1 },
      { title: "Accountant", id: 2 },
      { title: "Hospital Head", id: 3 },
    ],
    required: true,
    isFullWidth: false,
  },
];

export const userManagementCards = [
  {
    id: 1,
    name: "Total Users",
    value: "20",
    icon: userBlue,
    color: "#4CAF50",
  },
  {
    id: 2,
    name: "Active Users",
    value: "15",
    icon: userGreen,
    color: "#2196F3",
  },
  {
    id: 3,
    name: "Pending Invitations",
    value: "07",
    icon: userOrange,
    color: "#FF9800",
  },
  {
    id: 4,
    name: "Deactivated Users",
    value: "03",
    icon: userRed,
    color: "#F44336",
  },
];
